import React from "react";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";

import { PageContent, Container, Content } from "common/layout";
import { H1 } from "common/text";

import photo404 from "assets/ltl-404.jpg";

const Page404 = () => {
  const { t } = useTranslation("error");

  const renderImage = () => <img src={photo404} alt="ltl-404" />;

  return (
    <PageContent style={{ backgroundColor: "white" }}>
      <Container>
        <Content>
          <Row style={{ marginTop: 50 }} gutter={24}>
            <Col md={{ span: 10, offset: 2 }} sm={24}>
              <H1>
                {t("Sorry, we got confused…")}
                <br />
                {t("The page you are looking for is missing.")}
              </H1>
              <p style={{ fontSize: 16, textAlign: "justify" }}>
                {t("Please contact us at")}{" "}
                <a href="mailto:support@flexiclasses.com">
                  support@flexiclasses.com
                </a>{" "}
                {t("with any questions you might have.")}
              </p>
            </Col>
            <Col md={{ span: 8, offset: 0 }} sm={24}>
              {renderImage()}
            </Col>
          </Row>
        </Content>
      </Container>
    </PageContent>
  );
};

export default Page404;
